<template>
    <div>
        <div class="flex mt-4 justify-between items-center gap-4">
            <div class="flex mt-4 gap-4">
                <div class="input-wrapper">
                    <label for="cost-center" class="">Base currency</label>
                    <el-select multiple v-model="category"  placeholder="--Filter by Category">
                        <el-option
                        label="Nigeria (NGN)"
                        value="tag.id"
                        >
                        </el-option>
                    </el-select>
                </div>
                <div class="input-wrapper">
                    <!-- <label for="cost-center" class="">Tags</label> -->
                    <el-select multiple v-model="category"  placeholder="--Filter by Outlets">
                        <el-option
                        label="tag.name"
                        value="tag.id"
                        >
                        </el-option>
                    </el-select>
                </div>
            </div> 
            <base-button text="+ New Exchange Rate"  @click="showAddExchangeModal = true"/>
        </div>
        <table class="custom-table mt-8 w-100">
             <thead>
                 <tr>
                     <th>CURRENCY</th>
                     <th>CUNVERSION</th>
                     <th>EXCHANGE RATE</th>
                     <th>OUTLETS</th>
                     <th>LAST UPDATED</th>
                     <th>LAST UPDATED BY</th>
                 </tr>
             </thead>
             <tbody>
                 <tr>
                     <td>1</td>
                     <td>
                         <svg width="11" height="10" viewBox="0 0 11 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="5.5" cy="5" r="5" fill="#13B56A"/>
                        </svg>
                     </td>
                     <td>Apata ganga</td>                     
                     <td><span> Salary</span></td>
                     <td>
                         <div class="flex gap-2 items-center">
                            <span class="">3</span>
                            <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.8309 9C13.8309 10.1046 12.9355 11 11.8309 11C10.7264 11 9.83093 10.1046 9.83093 9C9.83093 7.89543 10.7264 7 11.8309 7C12.9355 7 13.8309 7.89543 13.8309 9Z" fill="#10233E"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8309 0C6.23941 0 1.54111 3.82432 0.208984 9C1.54111 14.1757 6.23941 18 11.8309 18C17.4224 18 22.1207 14.1757 23.4529 9C22.1207 3.82432 17.4224 0 11.8309 0ZM15.8309 9C15.8309 11.2091 14.0401 13 11.8309 13C9.62179 13 7.83093 11.2091 7.83093 9C7.83093 6.79086 9.62179 5 11.8309 5C14.0401 5 15.8309 6.79086 15.8309 9Z" fill="#10233E"/>
                            </svg>
                         </div>
                    </td>
                    <td>
                        Scello Limited
                        <p>Wema bank</p>
                     </td>
                     <td>
                         <img src="@/assets/images/icons/edit.svg" />
                     </td>
                 </tr>
             </tbody>
        </table>
        <hr>
        <div class="flex justify-between">
            <p class="cursor-pointer ">Cancel</p>
            <base-button text="Save" />
        </div>
        <add-exchange-modal :showModal="showAddExchangeModal" @close-modal="showAddExchangeModal = false"/>
    </div>
</template>

<script>
import AddExchangeModal from "../Modals/AddExchangeModal"

export default{
    components:{
        AddExchangeModal
    },
    data(){
        return {
            querySearch: '',
            category: "",
            showAddExchangeModal: false 
        }
    }
}
</script>

<style lang="scss">


</style>